<template>
  <div
    class="fixed bottom-4 right-0 z-[10001] transform transition-transform duration-300"
    :class="[visible ? '-translate-x-4' : 'translate-x-full']"
  >
    <div
      @click="hide"
      class="flex min-w-[350px] max-w-[640px] cursor-pointer items-center justify-between gap-5 rounded-lg p-4"
      :class="[
        type === 'error'
          ? 'bg-danger-100'
          : type === 'info'
            ? 'bg-info-100'
            : 'bg-success-100',
      ]"
    >
      <p
        class="text-[14px] font-semibold text-white-100 drop-shadow-md first-letter:capitalize"
      >
        {{ message }}
      </p>
      <span class="-mx-1 mt-[1px] block text-white-100"
        ><CircleX :size="20" :stroke-width="2"
      /></span>
    </div>
  </div>
</template>

<script>
import { useToastStore } from "@S/toast";
import { CircleX } from "lucide-vue-next";

export default {
  name: "Toast",
  components: {
    CircleX,
  },
  setup() {
    const toastStore = useToastStore();
    return { toastStore };
  },
  computed: {
    visible() {
      return this.toastStore.visible;
    },
    message() {
      return this.toastStore.message;
    },
    type() {
      return this.toastStore.type;
    },
  },
  methods: {
    hide() {
      this.toastStore.hide();
    },
  },
};
</script>
